export default "__VITE_ASSET__72867de4__"